import { fromPromise } from 'rxjs/observable/fromPromise';
import { of } from 'rxjs/observable/of';
import { filter } from 'rxjs/operators/filter';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { startWith } from 'rxjs/operators/startWith';
export default function requestEntity(requestEpicDescriptor) {
  return ($action, {
    getState
  }) => {
    return $action.ofType(requestEpicDescriptor.getInitiatingActionType()).pipe(filter(() => requestEpicDescriptor.getRequestStatusTypeFilters().indexOf(requestEpicDescriptor.getRequestStatus(getState())) !== -1), mergeMap(action => {
      return fromPromise(requestEpicDescriptor.makeAPICall(action.payload.data)).pipe(map(response => requestEpicDescriptor.getSuccessAction()(response, action.payload.data)), catchError(error => of(requestEpicDescriptor.getFailureAction()(error, action.payload.data))), startWith(requestEpicDescriptor.getRequestAction()(action.payload.data)));
    }));
  };
}